let env = null;
if (process.env.REACT_APP_ENV === 'LOCALHOST') {
  env = 'local';
}
if (process.env.REACT_APP_ENV === 'DEVELOPMENT') {
  env = 'dev';
}
if (process.env.REACT_APP_ENV === 'STAGING') {
  env = 'stage';
}
if (process.env.REACT_APP_ENV === 'PRODUCTION') {
  env = 'prod';
}
const constants = {
  env,
  apiHost: process.env.REACT_APP_API_HOST,
  environment: process.env.REACT_APP_ENV,
  workspaceId: process.env.REACT_APP_WORKSPACE_ID,
  utilityHost: process.env.REACT_APP_API_UTILITY_HOST,
  userId: process.env.REACT_APP_USER_ID,
  sharePointName: process.env.REACT_APP_SHAREPOINT_NAME,
  sharePointUser: process.env.REACT_APP_SHAREPOINT_USER,
  onedriveUserId: process.env.REACT_APP_ONEDRIVE_USER_ID,
  adobeClientId: process.env.REACT_APP_ADOBE_CLIENT_ID,
};

export default constants;
